
"use client";

import { cn } from "@/lib/utils";
import type { CSSProperties } from "react";

/** Default: sticky on; set CMS to false to disable */
function pickPillSticky(
  raw: Record<string, unknown> | null | undefined,
): boolean {
  if (!raw) return true;
  const v = raw.featured_pill_sticky ?? raw.featuredPillSticky;
  if (v === undefined || v === null) return true;
  if (v === false || v === 0) return false;
  if (v === true || v === 1) return true;
  if (typeof v === "string") {
    const s = v.trim().toLowerCase();
    if (s === "false" || s === "0" || s === "no") return false;
  }
  return true;
}

function Header6({ data }: { data: any }) {
  const raw = data as Record<string, unknown> | undefined;
  const isPreview = Boolean(raw?.isPreview ?? raw?.is_preview);
  const sectionData = (raw?.data ?? raw) as Record<string, unknown> | null;

  const {
    status = true,
    featured_pill_text = "Limited Seats Available",
    featured_pill_show = true,
    featured_pill_bg_color = "#DB5803",
    featured_pill_border_color = "#DB5803",
    featured_pill_text_color = "#FFFFFF",
  } = (sectionData || {}) as {
    status?: boolean | number;
    featured_pill_text?: string;
    featured_pill_show?: boolean;
    featured_pill_bg_color?: string;
    featured_pill_border_color?: string;
    featured_pill_text_color?: string;
  };

  const off =
    !sectionData ||
    status === false ||
    status === 0 ||
    String(status) === "0";

  const showPill =
    !off &&
    featured_pill_show !== false &&
    Boolean(String(featured_pill_text ?? "").trim());

  const pillSticky = pickPillSticky(sectionData);
  const useSticky = showPill && pillSticky && !isPreview;

  if (!sectionData || !showPill) {
    return null;
  }

  const inner = (
    <div
      className="animate-breathing inline-flex max-w-[min(100vw-2rem,620px)] flex-col rounded-md border-2 border-solid p-1 min-[768px]:p-1.5"
      style={{ borderColor: featured_pill_border_color ?? "#DB5803" }}
    >
      <div
        className="flex items-center justify-center rounded-[6px] px-3 py-1.5 text-center text-xs font-semibold min-[768px]:px-3.5 min-[768px]:py-2 min-[768px]:text-sm"
        style={{
          backgroundColor: featured_pill_bg_color ?? "#DB5803",
          color: featured_pill_text_color ?? "#FFFFFF",
        }}
      >
        <span className="leading-snug">{featured_pill_text}</span>
      </div>
    </div>
  );

  const transparentRowClass = cn(
    "flex w-full items-center justify-center px-4 py-1.5 min-[768px]:py-2",
    "border-0 !bg-transparent shadow-none ring-0 outline-none [background-image:none]",
  );

  if (useSticky) {
    return (
      <div className="pointer-events-none h-0 w-full min-w-0 shrink-0 overflow-visible">
        <div
          className={cn(
            "fixed left-0 right-0 z-[85] flex w-full items-center justify-center px-4 py-1.5 min-[768px]:py-2",
            "border-0 !bg-transparent shadow-none ring-0 outline-none [background-image:none] pointer-events-none",
          )}
          style={
            {
              top:
                "calc(var(--header4-sticky-height, 0px) + var(--nav3-sticky-height, 0px) + var(--nav4-sticky-height, 0px))",
              backgroundColor: "transparent",
              backgroundImage: "none",
            } as CSSProperties
          }
        >
          <div className="pointer-events-auto">{inner}</div>
        </div>
      </div>
    );
  }

  return (
    <div
      className={transparentRowClass}
      style={{ backgroundColor: "transparent", backgroundImage: "none" }}
    >
      {inner}
    </div>
  );
}

export default Header6;
